export default __webpack_public_path__ + "static/char-sp03-anr-104ddf65e28ac197bff0972d24178e6f.gif";